'use strict';

module.exports = ['$scope', 'ngDroUAA', 'ngDroUtilsNotify', function ($scope, ngDroUAA, ngDroUtilsNotify) {


        /*
         * Init
         */

        // contiene i dati per la modifica della password
        $scope.token = {};

        /*
         * Methods
         */

        // Submit della form di modifica della password.
        $scope.passwordSubmit = function (isValid) {
            $scope.submitted = true;

            var passwordForm = this.formScope.passwordForm;


            var data = {
                password: $scope.token.password,
                oldPassword: $scope.token.oldPassword
            };


            if (isValid) {
                ngDroUAA.Profile.updatePassword(data)
                        .then(function (response) {
                            if (data.length > 0) {
                                angular.forEach(data, function (error) {
                                    passwordForm.oldPassword[error.code] = true;
                                });
                                return;
                            }
                            ngDroUtilsNotify.updateSuccess($scope.person.firstName.sformat($scope.person.lastName));
                        })
                        .catch(function (err) {
                            ngDroUtilsNotify.updateError($scope.person.firstName.sformat($scope.person.lastName),err);
                            passwordForm.oldPassword.not_match = true;
                            passwordForm.oldPassword.$error.required = false;
                        });
            }
        };

        // Chiusura della finestra.
        $scope.cancel = function () {
            $scope.submitted = false;
            $scope.token = {};
        };
    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/profile/profileDetail/tabs/password-form.js
// module id = 408
// module chunks = 0